// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___f2bW","newExpiryDate":"styles_newExpiryDate__1b6L7","footer":"styles_footer__1w9se"};